let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dNaIr")).then(() => parcelRequire('jDcuT'));